// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

/** Identity Platform tenant for app users (e.g. dva-users-uiupy). */
export const FIREBASE_AUTH_TENANT_ID =
  import.meta.env.VITE_FIREBASE_TENANT_ID || null;

/**
 * Ensure Auth is scoped to the configured tenant before login / token use.
 */
export function ensureAuthTenant() {
  if (FIREBASE_AUTH_TENANT_ID) {
    auth.tenantId = FIREBASE_AUTH_TENANT_ID;
  }
  return auth.tenantId;
}

ensureAuthTenant();
if (FIREBASE_AUTH_TENANT_ID) {
  console.log('🔐 Firebase Auth configured with tenant ID:', FIREBASE_AUTH_TENANT_ID);
}

export { db, auth };
